import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ModalService } from '@rocketfinancialcorp/rocket-ui/modal';

import { AttachmentDocument } from '@shared/models';

import { AttachmentPreviewModalComponent } from '../attachment-preview-modal/attachment-preview-modal.component';
import { PagerBreakpoint, PagerComponent, PagerItemDirective } from '../pager/pager.component';

/**
 * The landing page's attachments (KOR-15207, Figma 8329:1913): cards paged in the shared pager, whose header carries
 * the range and the arrows. The transaction-summary step keeps AttachmentsListComponent (rkt-carousel).
 */
@Component({
  selector: 'app-attachments-pager',
  templateUrl: './attachments-pager.component.html',
  styleUrls: ['./attachments-pager.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PagerComponent, PagerItemDirective, RktIconComponent],
})
export class AttachmentsPagerComponent {
  private modalService = inject(ModalService);

  attachments = input<AttachmentDocument[]>([]);

  // Two cards side by side as in the design; one on phones, where two would leave no room for the preview
  breakpoints: PagerBreakpoint[] = [
    { minWidth: 0, itemsVisible: 1 },
    { minWidth: 576, itemsVisible: 2 },
  ];

  preview(attachment: AttachmentDocument): void {
    const modal = this.modalService.open(AttachmentPreviewModalComponent, { className: 'attachments-modal' });
    modal.componentInstance.modalInitData(attachment);
  }
}
